const MEDIA_CONFIG = {
    MAIN_MEDIA_PREFIX: '/mymedia/'
};

export default MEDIA_CONFIG;